import { createAction, props } from '@ngrx/store';
import {ConsumerType} from '@emm/core/models/consumer-type.model';
import {SearchFilter} from '@emm/core/models/search-filter';

export enum ConsumerTypesAction {
    LoadAll = '[Consumer Types Management] Load All Consumer Types',
    LoadAllSuccess = '[Management API] Load All Consumer Types Success',
    LoadAllFailure = '[Management API] Load All Consumer Types Failure',
    Select = '[Consumer Types Management] Select Consumer Type',
    Search = '[Consumer Types Management] Search Consumer Type',
    OpenAddDialog = '[Consumer Types Management] Open Add Consumer Type Dialog',
}

export const ConsumerTypesActions = {
    loadAll: createAction(ConsumerTypesAction.LoadAll),
    loadAllSuccess: createAction(
        ConsumerTypesAction.LoadAllSuccess,
        props<{ consumerTypes: ConsumerType[] }>()
    ),
    loadAllFailure: createAction(ConsumerTypesAction.LoadAllFailure, props<{ error: any }>()),
    select: createAction(ConsumerTypesAction.Select, props<{ tag: string }>()),
    search: createAction(ConsumerTypesAction.Search, props<{ filter: SearchFilter }>()),
    openAddDialog: createAction(ConsumerTypesAction.OpenAddDialog),
};

export const AsyncActions = {
    loadActions: [ConsumerTypesActions.loadAll],
    successActions: [ConsumerTypesActions.loadAllSuccess],
    errorActions: [ConsumerTypesActions.loadAllFailure]
};
